import { useEffect, useState } from "react";

import { GqlFilterOption } from "~/__generated__";

export default function useCacheFilterOptions(
    /**@deprecated to be removed when we finish refactoring all the pages using filters  */
    options?: GqlFilterOption[] | null | undefined,
    total?: number,
): [GqlFilterOption[], number] {
    const [filterOptions, setFilterOptions] = useState<GqlFilterOption[]>([]);
    const [totalState, setTotal] = useState<number>(0);

    useEffect(() => {
        if (options) {
            setFilterOptions(current => {
                if (current.length > 0) return current;
                return options;
            });
        }
    }, [options]);

    useEffect(() => {
        if (total !== undefined) {
            setTotal(total);
        }
    }, [total]);

    return [filterOptions, totalState];
}
